import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getAuthErrorMessage } from '../../utils/authErrors';
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(getAuthErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-inner">
        <div className="login-illustration">
          <div className="login-illustration-circle">
            <img src={`${process.env.PUBLIC_URL || ''}/classroom.png`} alt="" className="login-illustration-img" />
          </div>
        </div>
        <div className="login-form-wrap">
          <h1 className="login-title">Log in to continue your learning journey</h1>
          <form onSubmit={handleSubmit} className="login-form">
            {error && <p className="login-error">{error}</p>}
            <label className="login-label">
              Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="login-input"
                required
                autoComplete="email"
                placeholder="Email"
              />
            </label>
            <label className="login-label login-label-password">
              Password
              <div className="login-password-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="login-input login-input-password"
                  required
                  autoComplete="current-password"
                  placeholder="Password"
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? (
                    <span className="login-password-eye">🙈</span>
                  ) : (
                    <span className="login-password-eye">👁️</span>
                  )}
                </button>
              </div>
            </label>
            <button type="submit" className="login-btn login-btn-continue login-btn-submit" disabled={loading}>
              {loading ? (
                <span className="btn-spinner" aria-label="Logging in" />
              ) : (
                'Continue'
              )}
            </button>
          </form>
          <p className="login-signup-prompt">
            Don&apos;t have an account? <Link to="/signup" className="login-signup-link">Sign up</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
